export default function () {
  return {
    user: null
  }
}
